import React, { useEffect, useState } from "react";
import { Button, Col, Form, Input, Row, Space } from "antd";
import { useAsyncAxios, utilAxiosWithAuth } from "../utils/customAxios";
import { AlertType, useAlert } from "../provider/AlertProvider";

import * as Types from "../commons/typeDTO";
import * as Request from "../commons/request";

const formItemLayout = {
    labelCol: {
        sm: {
            span: 5,
        },
    },
    wrapperCol: {
        sm: {
            span: 19,
        },
    },
};

function RegisterRentVideoManual({
    editMode,
    rentVideoManual,
    onRegisterRentVedioManual,
}: {
    editMode: string;
    rentVideoManual?: Types.RentVideoManualDto;
    onRegisterRentVedioManual?: () => void;
}) {
    const [form] = Form.useForm();
    const alert = useAlert();

    const [rentVideoManualName, setRentVideoManualName] = useState("");
    const [rentVideoManualUri, setRentVideoManualUri] = useState("");
    const [rentVideoManualImageUrl, setRentVideoManualImageUrl] = useState("");
    const [attachFiles, setAttachFiles] = useState<Array<any>>([]);

    const requestAxiosAddRentVideoManual = async (data: any) => {
        // console.log("data : " + data);

        const response = await utilAxiosWithAuth().post(Request.RENT_VIDEO_MANUAL_URL, data);

        return response.data;
    };

    const {
        loading: loadingAddRentVideoManual,
        error: errorAddRentVideoManual,
        data: resultAddRentVideoManual,
        execute: requestAddRentVideoManual,
    } = useAsyncAxios(requestAxiosAddRentVideoManual);

    useEffect(() => {
        if (rentVideoManual === undefined) return;

        form.setFieldsValue(rentVideoManual);
    }, [rentVideoManual]);

    useEffect(() => {
        if (resultAddRentVideoManual === null) return;

        if (onRegisterRentVedioManual) onRegisterRentVedioManual();

        alert.setAlert(AlertType.SUCCESS, "매뉴얼 추가 성공", "매뉴얼 추가를 완료하였습니다.");
    }, [resultAddRentVideoManual]);

    useEffect(() => {
        if (errorAddRentVideoManual === null) return;

        console.log("errorRentVideoManual", errorAddRentVideoManual);
        alert.setAlert(errorAddRentVideoManual.response.data.code, "매뉴얼 추가 실패", errorAddRentVideoManual.response.data.message);
    }, [errorAddRentVideoManual]);

    const requestAxiosUpdateRentVideoManual = async (data: Types.RentVideoManualDto, rentVideoManualId: number) => {
        console.log(data);
        const response = await utilAxiosWithAuth().put(Request.RENT_VIDEO_MANUAL_URL + "/" + rentVideoManualId, JSON.stringify(data));
        return response.data;
    };

    const {
        loading: loadingUpdateRentVideoManual,
        error: errorUpdateRentVideoManual,
        data: resultUpdateRentVideoManual,
        execute: requestUpdateRentVideoManual,
    } = useAsyncAxios(requestAxiosUpdateRentVideoManual);

    useEffect(() => {
        if (resultUpdateRentVideoManual === null) return;

        if (onRegisterRentVedioManual) onRegisterRentVedioManual();

        alert.setAlert(AlertType.SUCCESS, "매뉴얼 수정 성공", "매뉴얼 수정을 완료하였습니다.");
    }, [resultUpdateRentVideoManual]);

    useEffect(() => {
        if (errorUpdateRentVideoManual === null) return;

        console.log("errorUpdateRentVideoManual", errorUpdateRentVideoManual);
        alert.setAlert(errorUpdateRentVideoManual.response.data.code, "매뉴얼 수정 실패", errorUpdateRentVideoManual.response.data.message);
    }, [errorUpdateRentVideoManual]);

    useEffect(() => {
        console.log(editMode);
    }, [editMode]);

    const onFinish = async (values: Types.RentVideoManualDto) => {
        if (editMode === "add") requestAddRentVideoManual(values);
        else if (editMode === "update") requestUpdateRentVideoManual(values, values.rentVideoManualId);
    };

    return (
        <div>
            <Form form={form} onFinish={onFinish}>
                <Space size={20} direction="vertical" style={{ width: "100%" }}>
                    <div>
                        <Row>
                            <Col span={12}>
                                <Form.Item className="searchForm" {...formItemLayout} name="rentVideoManualId" label="매뉴얼 ID">
                                    <Input readOnly />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    className="searchForm"
                                    {...formItemLayout}
                                    name="rentVideoManualName"
                                    label="매뉴얼 이름"
                                    rules={[
                                        {
                                            required: true,
                                            message: "매뉴얼 이름을 입력해 주세요.",
                                        },
                                    ]}
                                >
                                    <Input placeholder="매뉴얼 이름을 입력해 주세요." onChange={(e) => setRentVideoManualName(e.target.value)} />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={12}>
                                <Form.Item
                                    className="searchForm"
                                    {...formItemLayout}
                                    name="rentVideoManualUri"
                                    label="동영상 주소"
                                    rules={[
                                        {
                                            required: true,
                                            message: "동영상 주소를 입력해 주세요.",
                                        },
                                    ]}
                                >
                                    <Input placeholder="동영상 주소을 입력해 주세요." onChange={(e) => setRentVideoManualUri(e.target.value)} />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    className="searchForm"
                                    {...formItemLayout}
                                    name="imageUrl"
                                    label="이미지 주소"
                                    rules={[
                                        {
                                            required: true,
                                            message: "이미지 주소를 입력해 주세요.",
                                        },
                                    ]}
                                >
                                    <Input placeholder="이미지 주소을 입력해 주세요." onChange={(e) => setRentVideoManualImageUrl(e.target.value)} />
                                </Form.Item>
                            </Col>
                        </Row>
                    </div>

                    <Row justify="end">
                        <Form.Item>
                            <Button type="primary" htmlType="submit">
                                {editMode === "add" ? "등록" : "수정"}
                            </Button>
                        </Form.Item>
                    </Row>
                </Space>
            </Form>
        </div>
    );
}

export default RegisterRentVideoManual;
